import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'boolean',
    standalone: true
})
export class BooleanPipe implements PipeTransform {
    transform(value?: boolean, trueVal: string = 'Yes', falseVal: string = 'No'): string {
        if (value === null || value === undefined) {
            return '';
        }
        return value ? trueVal : falseVal;
    }
}
